import React, { useEffect } from 'react';
import { FaBriefcase } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

const EmploymentDetails = ({
  role,
  employer,
  logo,
  logoUrl,
  logoWidth,
  logoHeight,
  city,
  duration,
  skills,
  description,
  employmentContainerRef,
}) => {
  //   const [isMobile, setIsMobile] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    const handleResize = () => {
      //   setIsMobile(window.innerWidth < 768);

      const verticalLineMargin = parseFloat(
        window.getComputedStyle(document.getElementById('vertical-line')).left
      );
      const dot = document.getElementById(`dot-${role}`);
      dot.style.left = `calc(-${verticalLineMargin}px - 8px)`;
      // dot.style.left = `-${verticalLineMargin}px`;

      // console.log('* ', verticalLineMargin);
      // console.log('**** ', dot.style.left);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [role]);

  return (
    <div>
      {/* <div id={`dot-${role}`} style={styles.dot}></div>  dot*/}
      {/* FaBriefcase */}
      <FaBriefcase id={`dot-${role}`} style={styles.dotPlace} />

      <div style={styles.employmentBox}>
        <div style={styles.role}>{role}</div> <br />
        {isMobile ? (
          <>
            <div style={styles.employerMobileContainer}>
              {employer} &nbsp;
              <a href={logoUrl} target='_blank' rel='noopener noreferrer'>
                <img
                  src={logo}
                  alt=''
                  style={{ width: logoWidth, height: logoHeight }}
                />
              </a>
            </div>
            <p>{city}</p>
            <p>{duration}</p>
          </>
        ) : (
          <div style={styles.detailsContainer}>
            <div style={styles.employerContainer}>
              {employer} &nbsp;
              {/* inline styling */}
              <a href={logoUrl} target='_blank' rel='noopener noreferrer'>
                <img
                  src={logo}
                  alt=''
                  style={{ width: logoWidth, height: logoHeight }}
                />
              </a>
            </div>
            <div style={styles.city}>{city} </div>
            <div style={styles.duration}>{duration}</div>
          </div>
        )}
        <ul style={styles.bullets}>
          {description.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <div>Tech: {skills}</div>
      </div>
    </div>
  );
};

const styles = {
  employmentBox: {
    // width: '200px',
    // width: '40%',
    // margin: '10px',
    padding: '10px',
    borderRadius: '5px',
    // textAlign: 'center',
    position: 'relative',
    border: '1px solid black',
    marginRight: '5px',
    background: 'white',
  },
  dotPlace: {
    position: 'absolute',
    top: '50%',
    // marginLeft: '-10%',    used dynamically in useEffect
    transform: 'translateY(-50%)',
  },
  //   dot: {
  //     position: 'absolute',
  //     top: '50%',
  //     // marginLeft: '-10%',    used dynamically in useEffect
  //     transform: 'translateY(-50%)',
  //     width: '10px',
  //     height: '10px',
  //     borderRadius: '50%',
  //     background: 'black',
  //   },
  employerMobileContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  employerContainer: {
    display: 'flex',
    alignItems: 'left',
  },
  city: {
    flex: '1',
    textAlign: 'center',
  },
  duration: {
    flex: '1',
    textAlign: 'center',
  },
  role: {
    fontWeight: 'bold',
  },
  bullets: {
    marginLeft: '-20px',
  },
};

export default EmploymentDetails;
